<form [formGroup]="realmForm" (ngSubmit)="onSubmit()">
  <div class="field-group">
    <label class="field-label">{{ 'company_taxno' | translate }}</label>
    <input
      type="text"
      formControlName="realm"
      class="field-input"
      [class.has-error]="realmForm.get('realm')?.invalid && realmForm.get('realm')?.touched"
      [placeholder]="'login_realm_placeholder' | translate"
      autocomplete="organization"
      [attr.disabled]="showLoading() ? '' : null" />
    @if (realmForm.get('realm')?.invalid && realmForm.get('realm')?.touched) {
      <div class="field-error">{{ 'login_realm_required' | translate }}</div>
    }
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'language' | translate }}</label>
    <p-select
      formControlName="selectedLanguage"
      [options]="languages()"
      optionLabel="label"
      optionValue="value"
      [disabled]="showLoading()"
      class="w-100"
      [style]="{ width: '100%' }"></p-select>
  </div>

  <button type="submit" class="btn-action" [disabled]="showLoading() || realmForm.invalid">
    @if (showLoading()) {
      <span class="spinner"></span>
      {{ 'connecting' | translate }}
    } @else {
      {{ 'continue' | translate }}
      <i [class]="isRtl() ? 'ph ph-arrow-left' : 'ph ph-arrow-right'" style="font-size: 1rem"></i>
    }
  </button>

  @if (errorStatus()) {
    <div class="alert-error">{{ errorMessage() | translate }}</div>
  }
</form>
